import i18n from 'i18n/config';
import { SingleValue } from 'react-select';
import { useEffect, useState } from 'react';

import { SelectorOption } from 'types';
import { boardVisibilityTypes } from 'modules/_shared/constants/boardVisibilityTypes';

type UseGetVisibilityOptionsProps = {
  visibility?: string;
};

const visibilityOptions = [
  {
    value: boardVisibilityTypes.VISIBLE.value,
    label: i18n.t(boardVisibilityTypes.VISIBLE.label),
  },
  {
    value: boardVisibilityTypes.NOT_VISIBLE.value,
    label: i18n.t(boardVisibilityTypes.NOT_VISIBLE.label),
  },
];

export const useGetVisibilityOptions = ({
  visibility,
}: UseGetVisibilityOptionsProps) => {
  const [selectedVisibility, setSelectedVisibility] = useState<string>('');
  const [selectedVisibilityOption, setSelectedVisibilityOption] =
    useState<SelectorOption | null>(null);

  const handleChangeVisibility = (option: SingleValue<SelectorOption>) => {
    if (option) {
      setSelectedVisibility(option.value);
      setSelectedVisibilityOption(option);
    }
  };

  useEffect(() => {
    if (visibility) {
      const selectedOption = visibilityOptions.find(
        (option) => option.value === visibility
      );
      setSelectedVisibility(visibility);
      setSelectedVisibilityOption(selectedOption || null);
    } else {
      const defaultOption = visibilityOptions.find(
        (option) => option.value === boardVisibilityTypes.NOT_VISIBLE.value
      );
      setSelectedVisibility(defaultOption?.value || '');
      setSelectedVisibilityOption(defaultOption || null);
    }
  }, [i18n.language]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    data: {
      visibilityOptions,
      selectedVisibility,
      selectedVisibilityOption,
    },
    actions: {
      handleChangeVisibility,
    },
  };
};
